<style scoped>
	.plan-card .button[disabled]:hover,
	.plan-card .button.disabled:hover {
		cursor: not-allowed;
	}
	.plan-card {
		min-height: 268px;
	}
	.dark .plan-card {
		border-color: #333;
	}
	.plan-comparison .button.disabled:hover {
		cursor: default;
	}
	.plan-card > header > h1 {
		margin-top: 0;
	}
	.plan-card > header {
		margin-bottom: 1.5em;
	}
	.plan-features.single .bullet .bullet-margin {
		display: none;
	}
	.plan-features.single .bullet .bullet-content {
		margin-left: 0;
	}
	.plan-features {
		text-align: left;
		margin: 0 0 2rem;
	}
	.plan-features li i:not(.success):not(.error){
		color: #2E88D6;
	}
	.plan-comparison .current-plan .plan-features li i:not(.success):not(.error){
		color: #777;
	}
	.plan-features li .bullet-margin {
		width: 1.5rem;
		text-align: left;
	}
	.plan-features li {
		line-height: 1.4rem;
		margin-bottom: .5rem;
	}
	.review-change .button.success.active + .button.success.active {
		display: none;
	}
	/* .plan-features li:before {
		content: '\f00c';
		font-family: 'Font Awesome 5 Free';
		font-weight: 900;
		margin-right: .5rem;
		color: #2E88D6;
	} */
	.plan-option:first-of-type {
		margin-top: auto;
	}
	.annual.badge {
		position: absolute;
		top: -.5rem;
		right: .5rem;
	}
	.plan-comparison .current-plan:not(.new-plan) .annual.badge {
		display: none;
	}
	.button {
		overflow: visible;
		text-align: center;
	}
	.button.active:before {
		content: '\f00c';
		font-family: 'Font Awesome 5 Free';
		font-weight: 900;
		position: absolute;
		left: 1rem;
	}
 	.button.new.active:before {
		color: #2E88D6;
	}
	.button.success.new.active:before {
		color: #fff;
	}

	h1.total {
		margin: 0;
	}
	h2 {
		line-height: 1.4em;
	}
	.half-width {
		max-width: calc(50% - .5rem);
		min-width: calc(50% - .5rem);
		width: calc(50% - .5rem);
	}
	.cost-summary {
		height: 86px;
		max-width: calc(50% - .5rem);
	    min-width: calc(50% - .5rem);
	    width: calc(50% - .5rem);
	}
	.change-summary {
		padding-right: 5rem;
		width: 50%;
	}
	.change-summary ul,
	.change-summary ul ul {
		list-style-type: none;
	}

	.payment-notice {
		margin: 0;
	}

	section {
		margin-bottom: 2rem;
	}

	footer.row button {
		width: 100%;
	}

	.notice a {
		font-weight: bolder;
	}

	@media only screen and (max-width : 1120px) {
		.plan-cards {
			width: 100%;
			box-sizing: border-box;
			flex-wrap: wrap;
		}

		.change-summary {
			width: 100%;
			padding-right: 0;
		}

		.row.separated-extra > .plan-comparison {
			min-width: 100%;
			margin-left: 0;
		}

		.review-change {
			flex-direction: column;
		}

		.plan-card {
		    box-sizing: border-box;
		}

		.change-plan-wrapper > header {
			background: white;
			position: sticky;
			top: 0;
			z-index: 2;
			padding: 1rem 0;
			box-sizing: border-box;
		}
		.dark .change-plan-wrapper > header {
			background: #1a1a1a;
		}
	}

	@media (min-width : 600px) and (max-width : 1120px) {
		.plan-card {
			min-width: calc(50% - .5rem);
			max-width: calc(50% - .5rem);
		    box-sizing: border-box;
			margin-left: 0;
		}

		.plan-card:nth-child(even) {
			margin-left: 1rem;
		}

		.plan-card:nth-child(odd) {
			margin-left: 0;
		}

		.plan-card:nth-child(n+3) {
			margin-top: 1rem;
		}
	}

	@media only screen and (max-width : 599px) {
		.change-plan-wrapper > header.row {
			flex-direction: column;
		}

		.row.separated .flexible.cost-summary {
			min-width: 100%;
			margin-left: 0;
		}
		.plan-cards {
			flex-direction: column;
		}

		.plan-card + .plan-card {
			margin-top: 1rem;
			margin-left: 0;
		}

		.review-change footer.row {
			flex-direction: column-reverse;
		}

		.review-change footer.row button + button {
			margin-left: 0;
			margin-bottom: 1rem;
		}
	}

	@media only screen and (max-width : 415px) {
		.cost-summary h4 {
			margin-bottom: .25rem;
			white-space: nowrap;
		}
		.cost-summary h1 {
			margin-top: 1em;
		}
	}

	@media only screen and (min-width : 600px) and (max-width : 775px) {
		.cost-summary h4 {
			margin-bottom: .25rem;
			white-space: nowrap;
		}
		.cost-summary h1 {
			margin-top: 1em;
		}
	}

</style>

<template>
	<form class="column flexible detail-page content content-900 drive">
		<header class="column">
			<div class="row centering separated">
				<button class="link" title="Go to Account Home" @click="leavePlan" type="button" name="button"><i class="fas fa-arrow-left"></i></button>
				<h1-placeholder :text="'TekDrive Subscription'" v-if="pageLoading"></h1-placeholder>
				<h1 class="gap" v-else>
					Your TekDrive Subscription
				</h1>
			</div>
		</header>

		<div v-if="redirectReason">
			<p v-if="redirectReason === 'expired'" class="notice warn subscription-expired">
				Your subscription has expired. Select a new subscription below to continue using this account.
			</p>
		</div>

		<div class="column change-plan-wrapper">
			<header class="row rigid separated centering">
				<div v-if="pageLoading" class="flexible row separated-extra baseline">
					<h2-placeholder :text="'Your Plan'"></h2-placeholder>
				</div>
				<div v-else class="flexible row separated-extra baseline">
					<h2 class="rigid">Your Plan</h2>
				</div>
				<div :class="{invisible:pageLoading}" class="flexible card card-secondary row centering cost-summary">
					<div class="row flexible separated centering">
						<div class="column separated flexible">
							<h4 v-if="current && current.expiry" class="flexible">
								Ends {{current && current.expiry | date}}
							</h4>
							<h4 v-else class="flexible">
								Never Ends
							</h4>
							<small class="gray-6 row rigid" v-if="current.isPrepaid"><div class="badge badge-hollow trailing-off" :title="current.prepaidDisplayCode">{{current.prepaidDisplayCode}}</div></small>
							<small class="gray-6 row rigid" v-else-if="current.isOneTimeOffer">One-time offer</small>
							<small v-else class="gray-6 rigid">Won't auto-renew</small>
						</div>

						<h1 class="total rigid">
							<strong v-if="current.isPrepaid">Prepaid</strong>
							<strong v-else-if="current.isFreePromo">Free</strong>
							<strong v-else>Trial</strong>
						</h1>
					</div>
				</div>
			</header>

			<plan-card-placeholder v-if="pageLoading" :items="1"></plan-card-placeholder>

			<!-- prepaid plan -->
			<div class="column separated-extra" v-if="currentPlan">
				<div class="rigid row plan-cards plan-cards-prepaid">
					<div class="plan-card column current-plan">
						<header class="row separated">
							<h1 class="plan-title rigid">{{currentPlan.name}}</h1>
						</header>
						<ul class="plan-features" :class="{'single' : Object.keys(currentPlan.details).length === 1}">
							<li v-if="currentPlan.details.storageSizeLimit" class="bullet">
								<div class="bullet-margin"><i class="fas fa-check"></i></div>
								<div class="bullet-content">{{currentPlan.details.storageSizeLimit.displayValue}}</div>
							</li>
							<li v-if="currentPlan.details.sharingType" class="bullet">
								<div class="bullet-margin"><i class="fas fa-check"></i></div>
								<div class="bullet-content">{{currentPlan.details.sharingType.displayValue}}</div>
							</li>
							<li v-if="currentPlan.details.accessKeyLimit" class="bullet">
								<div class="bullet-margin"><i class="fas fa-check"></i></div>
								<div class="bullet-content">{{currentPlan.details.accessKeyLimit.displayValue}}</div>
							</li>
						</ul>
					</div>
				</div>
				<div v-if="current.isPrepaid" class="notice flexible info bottom">
					This subscription is prepaid and cannot be modified here. If you’d like to make changes, please <a href="mailto:plans@support.tekcloud.com?subject=Subscription%20Code%20Limitations">email us</a>.
				</div>
			</div>
		</div>
	</form>
</template>

<script>
import capitalize from '../filters/capitalize';
import currency from '../filters/currency';
import byte from '../filters/byte';
import date from '../filters/date';
import PaymentNotice from '../components/PaymentNotice';
import Popover from '../components/Popover';
import Spinner from '../components/Spinner';
import PlanCardPlaceholder from '../components/PlanCardPlaceholder';
import H1Placeholder from '../components/H1Placeholder';
import H2Placeholder from '../components/H2Placeholder';
import TablePlaceholder from '../components/TablePlaceholder';
import TrialBadge from '@/components/TrialBadge';
import { mapGetters, mapState, mapActions } from 'vuex';
import Vue from 'vue';

export default {
	name: 'DriveSubView',
	filters: {
		currency,
		date,
		capitalize,
		byte
	},
	directives: {
		scrollTo
	},
	components: {
		PaymentNotice,
		Spinner,
		PlanCardPlaceholder,
		H1Placeholder,
		H2Placeholder,
		TablePlaceholder,
		Popover,
		TrialBadge
	},
	data() {
		return {
			currentPlan: null,
			subscriptionLoading: false,
			getSubscriptionError: null
		};
	},
	computed: {
		...mapGetters({
			account: 'account',
			accountStatus: 'accountStatus',
			isUserLoaded: 'isUserLoaded',
			driveAppUrl: 'auth/driveAppUrl',
			currentTrial: 'drive/trialDriveSub',
		}),
		...mapState('drive', {
			current: 'currentSubscription',
			plansMap: 'mappedPlans',
		}),
		...mapState('auth', [
			'refreshToken'
		]),
		isPrepaidPlan() {
			return this.current && this.current.isPrepaid;
		},
		isPromoPlan() {
			return this.current && this.current.isPromo;
		},
		prepaidPlan() {
			return this.currentPlan;
		},
		pageLoading() {
			return !this.currentPlan || this.subscriptionLoading;
		},
		redirectReason() {
			return this.$route.query && this.$route.query.r;
		},
	},
	methods: {
		selectCurrentPlan(current, old){
			if (!current) {
				return;
			};
			const currentPlanFromSub = current && current.plan;
			this.currentPlan = this.getCurrentPlan(currentPlanFromSub);
		},
		getCurrentPlan(currentPlanFromSub) {
			if (this.plansMap[currentPlanFromSub.id]) {
				return this.plansMap[currentPlanFromSub.id];
			} else if (this.plansMap[currentPlanFromSub.id + '_' + currentPlanFromSub.interval]) {
				return this.plansMap[currentPlanFromSub.id + '_' + currentPlanFromSub.interval];
			} else {
				return {
					active: true,
					amount: null,
					contactForPricing: true,
					customBilling: false,
					details: {},
					hasTrial: false,
					id: currentPlanFromSub.id,
					interval: "monthly",
					name: currentPlanFromSub.name,
					paymentMethodRequired: true,
				};
			}
		},
		getInterval(plan) {
			return (!plan.interval || plan.interval === 'free') ? 'monthly' : plan.interval;
		},
		onButtonClick() {
			this.touched = true;
			this.removeNotices();
		},
		leavePlan() {
			this.$store.dispatch('drive/TEAR_DOWN');
			this.$router.push('/');
		},
	},
	created() {
		let vm = this;
		vm.subscriptionLoading = true;
		vm.$store.dispatch('drive/GET_SUBSCRIPTION_REQUEST',  { subId: vm.$route.params.subId })
			.then(()=>{
				vm.subscriptionLoading = false;
			})
			.catch(error => {
				vm.subscriptionLoading = false;
				vm.getSubscriptionError = error;
			});
	},
	watch: {
		current: {
			handler: 'selectCurrentPlan',
			immediate: true
		}
	},
};
</script>




// WEBPACK FOOTER //
// ./src/views/DriveSubView.vue